import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LanguageContext } from './languagecontext';
import ClipLoader from "react-spinners/ClipLoader";
import API from '../pages/Services/Baseservice';
import SEO from "./SEO";
const Faq = () => {
  const faqRef = useRef([]);
  const location = useLocation();
  const [faqList, setFaqList] = useState([]);
  const [search, setSearch] = useState("");
  const [openIndex, setOpenIndex] = useState(null);
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [faqLoading, setFaqLoading] = useState(false);
  const { selectedLanguage } = useContext(LanguageContext);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    fetchCategories();
    fetchFAQs();
  }, [selectedLanguage.id]);

 useEffect(() => {
  if (categories.length === 0) return;

  const delayDebounce = setTimeout(() => {
    fetchFAQs();    
  }, 500);

  return () => clearTimeout(delayDebounce); 
}, [search, category, categories]);


  const fetchCategories = () => {
    setLoading(true);
    let req = {
      language_id: selectedLanguage.id
    }
    API.post("webfaqsCategory_list/webCondition", req, {
      search: "",
      status: "",
    })
      .then((res) => {
        const data = res.data?.data?.data || res.data?.data || [];
        setCategories(data);
      })
      .catch((err) => console.error("Error fetching categories:", err))
      .finally(() => setLoading(false));
  };

  const fetchFAQs = () => {
    setFaqLoading(true);
    const payload = {
      search: search || "",
      category_id: category || "",
      language_id: selectedLanguage.id
    };

    API.post("webFaqs_list/webCondition", payload)
      .then((res) => {
        const faqData = res?.data?.data?.data || [];
        setFaqList(faqData);
      })
      .catch((err) => console.error("Failed to fetch FAQs:", err))
      .finally(() => setFaqLoading(false));
  };

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const removeInlineStyles = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    doc.querySelectorAll("[style]").forEach((el) => {
      el.removeAttribute("style");
    });
    return doc.body.innerHTML;
  };

  const home = () => {
    navigate("/");
  }

  const mid = Math.ceil(faqList.length / 2);
  const leftItems = faqList.slice(0, mid);
  const rightItems = faqList.slice(mid);

  const scrollIndex = location.state?.faqIndex ?? null;

  useEffect(() => {
    setTimeout(() => {
      if (
        scrollIndex !== null &&
        faqRef.current &&
        faqRef.current[scrollIndex]
      ) {
        const element = faqRef.current[scrollIndex];
        const yOffset = -150;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
        handleToggle(scrollIndex);
        navigate(location.pathname, { replace: true });
      }
    }, 150);
  }, [scrollIndex, faqList]);

  const scrollToFaq = location.state?.scrollToFaq ?? false;

  useEffect(() => {
    if (!scrollToFaq || faqList.length === 0) return;

    setTimeout(() => {
      const section = document.getElementById("faq-section");
      if (!section) return;
      const y = section.getBoundingClientRect().top + window.pageYOffset - 150;
      window.scrollTo({ top: y, behavior: "smooth" });
      navigate(location.pathname, { replace: true });
    }, 200);
  }, [scrollToFaq, faqList]);

  return (
    <div>
       <SEO
        title="Canadian immigration advisor | Best immigration consultant Canada"
        description="Find clear answers in the ASRA Immigration FAQ from a trusted Canadian immigration advisor, covering visas, PR, eligibility, timelines, and application support."
        canonical="https://asraimmigration.ca/faq"
      />
      {loading ? (
        <div className="d-flex justify-content-center align-items-center p-5 mt-5 expressentryheight vh-100" >
          <ClipLoader color="#FF050C" size={50} />
        </div>
      ) : (
        <div className="container px-3">
          <section className="faq-hero container p-4 p-lg-5 rounded-5 ">
            <h1>FAQ</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item cursorpointer" onClick={home}>
                  <a>{selectedLanguage.id === 1 ? 'Home' : 'Accueil'}</a>
                </li>
                <li className="breadcrumb-item active">FAQ</li>
              </ol>
            </nav>
          </section>

          <section className="faq-categories p-3 p-lg-5 container mt-lg-5 pt-lg-5">
            <div className="row g-3">
              {categories.length === 0 ? (
                <p className="text-center" style={{ fontWeight: "bold" }}>
                  {selectedLanguage.id === 1 ? 'No categories found' : 'Aucune catégorie trouvée'}
                </p>
              ) : (
                categories.map((cat, index) => (
                  <div className="col-xl-4 col-md-6 col-fluid" key={cat.category_id || index}>
                    <button
                      className={`faq-btn text-start ${category === cat.category_id ? 'active' : ''}`}
                      onClick={() => setCategory(cat.category_id)}
                    >
                      <span className="d-none d-sm-block">{cat.category}</span>
                      <span className="d-block d-sm-none">{cat.category}</span>
                      <i className="bi bi-arrow-right-short"></i>
                    </button>
                  </div>
                ))
              )}
            </div>
          </section>

          <section className="faq-section">
            <div className="d-flex justify-content-between align-items-center flex-wrap mb-5">
              <h4 className="faq-header m-md-0">
                {selectedLanguage.id === 1 ? 'Search Here. What you want to know' : 'Recherchez ici ce que vous voulez savoir'}
              </h4>
              <div className="search-wrapper m-0">
                <input
                  type="text"
                  placeholder={selectedLanguage.id === 1 ? "Search.." : "Rechercher"}
                  className="search-input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <i className="bi bi-search search-icon"></i>
              </div>
            </div>

            {faqLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <ClipLoader color="#FF050C" size={50} />
              </div>
            ) : faqList.length === 0 ? (
              <p className="text-center mt-5" style={{ fontWeight: "bold" }}>
                {selectedLanguage.id === 1 ? 'No FAQ Found' : 'Aucune FAQ trouvée'}
              </p>
            ) : (
              <div className="row " id="faq-section">
                <div className="col-md-6">
                  {leftItems.map((item, index) => (
                    <div key={index} ref={el => faqRef.current[index] = el}>
                      <div
                        className={`faq-card p-3 ${openIndex === index ? 'active' : ''}`}
                        onClick={() => handleToggle(index)}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <h6 className="faq-title mb-0 fw-semibold">{item.question}</h6>
                          <button className="arrow-btn"><i className="bi bi-chevron-right"></i></button>
                        </div>
                        <p
                          className="faq-content"
                          dangerouslySetInnerHTML={{ __html: removeInlineStyles(item.answers) }}
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="col-md-6">
                  {rightItems.map((item, index) => {
                    const realIndex = index + mid;
                    return (
                      <div key={realIndex} ref={el => faqRef.current[realIndex] = el}>
                        <div
                          className={`faq-card p-3 ${openIndex === realIndex ? 'active' : ''}`}
                          onClick={() => handleToggle(realIndex)}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="faq-title mb-0 fw-semibold">{item.question}</h6>
                            <button className="arrow-btn"><i className="bi bi-chevron-right"></i></button>
                          </div>
                          <p
                            className="faq-content"
                            dangerouslySetInnerHTML={{ __html: removeInlineStyles(item.answers) }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
                <div class="btn-pair1 mb-3  d-lg-flex d-none ">
                <a class="nav-link" onClick={()=>navigate("/blog")}>
                    <button class="btn btn-danger d-flex align-items-center justify-content-center">
                        <p class="p-0 m-0">{selectedLanguage.id === 1 ? 'Recent Blogs' : 'Blogues récents'}</p>
                        <i class="bi bi-arrow-right-circle-fill ms-1 book-icon"></i>
                    </button>
                </a>
            </div>
          </section>
        </div>
      )}
    </div>
  );
};

export default Faq;